module.exports = __webpack_public_path__ + "img/bg0.d26d8788.png";